import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './ComparisonNotification.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ComparisonNotification = _ref => {
  let {
    text,
    control,
    onMouseEnter
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: styles['container'],
    onMouseEnter: onMouseEnter,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles['notification'],
      children: [/*#__PURE__*/_jsx(UIText2, {
        whiteSpace: "pre-line",
        color: "text-inverted-default",
        children: text
      }), /*#__PURE__*/_jsx("div", {
        className: styles['control'],
        children: control
      })]
    })
  });
};